export const keys = {
  create: (orderId: string) => [
    'mutation',
    'windows',
    'position',
    'create',
    orderId,
  ],
  duplicate: (positionId: string) => [
    'mutation',
    'windows',
    'position',
    'duplicate',
    positionId,
  ],
  delete: (positionId: string) => [
    'mutation',
    'windows',
    'position',
    'delete',
    positionId,
  ],
  getOne: (positionId: string) => ['windows', 'position', positionId],
  getAll: (orderId: string) => ['windows', 'order', orderId, 'positions'],
  update: (positionId: string) => [
    'mutation',
    'windows',
    'position',
    'update',
    positionId,
  ],
};
